export const arrowAnchor = (function ($) {

    const $arrow = $(".js-arrow-anchor");

    function init() {
        $arrow.on("click", function () {
            $("html,body").animate({
                scrollTop: $(this).offset().top + 60,
            }, 0);
        });
    }

    return {
        init: init
    }

})(jQuery);
